import { BaseService } from './base-service'

class ScreenService extends BaseService {
  constructor() {
    super('/screen')
  }
}

export const screenService = new ScreenService()
